import { Badge } from 'antd';
import { history } from 'ice';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import client from '@/lib/feathers';
import { getNewMessage, receivedNewMessage } from '@/redux/slices/userSlice';

import styles from './MobileHomeNotice.module.scss';

const MobileHomeNotice = (props) => {
  const messageService = client.service('message');
  const [badgeCount, setBadgeCount] = useState(0);

  const hasNewMessage = useSelector((state) => state.user.hasNewMessage);
  const dispatch = useDispatch();
  useEffect(() => {
    client
      .reAuthenticate()
      .then((data) => {
        console.log('==relogin ok', data.user);

        messageService
          .find({
            query: {
              userId: data.user._id,
              readed: false,
              $sort: {
                createdTime: -1,
              },
              $limit: 10,
            },
          })
          .then((res) => {
            console.log('==find messages success:', res.data);
            setBadgeCount(res.data.length);
            props.setMsgData(res);
            dispatch(receivedNewMessage());
          })
          .catch((err) => {
            console.log('==find messages fail:', err);
          });
      })
      .catch((err) => {
        console.log('==relogin fail');
        // history.push('/user/login');
      });
  }, [dispatch, hasNewMessage]);

  useEffect(() => {
    messageService.on('msg', () => {
      dispatch(getNewMessage());
    });
  }, [dispatch, messageService]);

  async function viewNotices() {
    history.push('/mobile/noticeRecord');
  }

  return (
    <div className={styles.noticeIcon} onClick={viewNotices}>
      <Badge dot count={badgeCount}>
        <img
          className={styles.noticeImg}
          src="icon/ic_notifiction.svg"
          alt="Ic_notifiction icon"
        />
      </Badge>
    </div>
  );
};

export default MobileHomeNotice;
